import { Component, HostBinding, Input, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyI18NModule } from '@vendasta/galaxy/i18n';

@Component({
  selector: 'glxy-page-no-access-unauthorized',
  imports: [GalaxyEmptyStateModule, MatIconModule, GalaxyI18NModule, TranslateModule],
  templateUrl: './page-no-access-unauthorized.component.html',
  styleUrls: ['./page-no-access-unauthorized.component.scss'],
})
export class PageNoAccessUnauthorizedComponent implements OnInit {
  @HostBinding('class') class = 'glxy-page-no-access-unauthorized';

  @Input() size: 'normal' | 'small' = 'normal';
  @Input() icon = 'lock_person';
  @Input() title = 'GALAXY.PAGE_NO_ACCESS.TITLE';
  @Input() subtitle = 'GALAXY.PAGE_NO_ACCESS.SUBTITLE';

  @HostBinding('class.size-small') get isSmall() {
    return this.size === 'small';
  }

  activatedRoute = inject(ActivatedRoute);

  ngOnInit() {
    if (this.activatedRoute.snapshot.data.size === 'small') {
      this.size = 'small';
    }
    if (this.activatedRoute.snapshot.data.icon) {
      this.icon = this.activatedRoute.snapshot.data.icon;
    }
    if (this.activatedRoute.snapshot.data.title) {
      this.title = this.activatedRoute.snapshot.data.title;
    }
    if (this.activatedRoute.snapshot.data.subtitle) {
      this.subtitle = this.activatedRoute.snapshot.data.subtitle;
    }
  }
}
